import React from 'react';
import { ConsultationForm } from './components/ConsultationForm';
import { Helmet } from 'react-helmet';
export function App() {
  return <>
      <Helmet data-id="element-0">
        <title data-id="element-1">
          Online Treatment / Consultation Form (ऑनलाइन उपचार / परामर्श प्रपत्र)
        </title>
        <meta property="og:title" content="Online Treatment / Consultation Form (ऑनलाइन उपचार / परामर्श प्रपत्र)" data-id="element-2" />
      </Helmet>
      <div className="w-full min-h-screen bg-gray-100 py-4 sm:py-8 px-2 sm:px-4" data-id="element-3">
        <ConsultationForm data-id="element-4" />
      </div>
    </>;
}